export const playerSettingsDg = `
	<div class="screen-overlay">
		<div class="player-settings-window dialog">
			<div class="dialog-header">Player Settings</div>
			<div class="dialog-fields-section">
				<div class="dialog-section-header">Note Names</div>
				<div class="dialog-checkbox">
					<label class="psw-fingerings-text"><input class="psw-fingeringsCb" 
						type="checkbox"/>Show note names.</label>
				</div>
				<hr class="dialog-divider"/>
			</div>
			<div class="dialog-buttons-section">
				<button class="psw-closeBtn dialog-button">Close</button>
			</div>
		</div>
	</div>
	`;